import CryptoJS from "crypto-js";

const OBFUSCATION_KEY = "m$L!nk5_0bfu5c@t3_k3y_2024#";

export function encryptPayload(data) {
    const json = JSON.stringify(data);
    return CryptoJS.AES.encrypt(json, OBFUSCATION_KEY).toString();
}

export function decryptPayload(ciphertext) {
    const bytes = CryptoJS.AES.decrypt(ciphertext, OBFUSCATION_KEY);
    const json = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(json);
}
